export const L10N = {
  LABEL_ONLY_FOR_ROOM: { id: 'core.label.only_for_room' },
};
